import React from 'react';
import PropTypes from 'prop-types';

import { ChatContextProvider } from './ChatContext';
import { FirebaseContextProvider } from './FirebaseContext';
import ChatChannelContextProvider from './ChatChannelContext/ChatChannelContextProvider';
import ChatChannelListContextProvider from './ChatChannelListContext/ChatChannelListContextProvider';
import MessageInputContextProvider from './MessageInputContext/MessageInputContextProvider';

const WrappedComponent = ({ Component, chatProps, ...props }) => (
  <FirebaseContextProvider firebase={chatProps.firebase}>
    <ChatContextProvider
      chatUserId={chatProps.chatUserId}
      selectedPodId={chatProps.selectedPodId}
      sessionStore={chatProps.sessionStore}
      mediaRecorder={chatProps.mediaRecorder}
      posthog={chatProps.posthog}
      logEvent={chatProps.logEvent}
      isSmartContextEnabled={chatProps.isSmartContextEnabled}
      isVoiceNotePilotCoach={chatProps.isVoiceNotePilotCoach}
    >
      <ChatChannelListContextProvider>
        <ChatChannelContextProvider
          navigateToClientPage={chatProps.navigateToClientPage}
          renderHeaderExtras={chatProps.renderHeaderExtras}
          parentApp={chatProps.parentApp}
        >
          <MessageInputContextProvider>
            <Component {...props} />
          </MessageInputContextProvider>
        </ChatChannelContextProvider>
      </ChatChannelListContextProvider>
    </ChatContextProvider>
  </FirebaseContextProvider>
);

WrappedComponent.propTypes = {
  chatProps: PropTypes.shape({
    firebase: PropTypes.object.isRequired,
    chatUserId: PropTypes.string.isRequired,
    selectedPodId: PropTypes.string.isRequired,
    sessionStore: PropTypes.object.isRequired,
    posthog: PropTypes.object.isRequired,
    mediaRecorder: PropTypes.object.isRequired,
    navigateToClientPage: PropTypes.func,
    renderHeaderExtras: PropTypes.func,
    logEvent: PropTypes.func,
    parentApp: PropTypes.oneOf(['web', 'mobile']),
    isSmartContextEnabled: PropTypes.bool,
    isVoiceNotePilotCoach: PropTypes.bool,
  }).isRequired,
  Component: PropTypes.elementType.isRequired,
};

const withChat = (Component) => (props) => (
  <WrappedComponent Component={Component} {...props} />
);

export default withChat;
